import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2029b7de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "notion-menu-wrapper"
}
const _hoisted_2 = {
  class: "notion-nav",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "notion-nav-heading"
}
const _hoisted_4 = {
  key: 0,
  class: "notion-nav-icon"
}
const _hoisted_5 = { class: "notion-nav-label" }
const _hoisted_6 = { class: "notion-nav-item notion-nav-item--toggle" }
const _hoisted_7 = {
  key: 0,
  class: "notion-nav-icon"
}
const _hoisted_8 = { class: "notion-nav-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-nav-arrow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-nav-dot" }, null, -1))
const _hoisted_11 = { class: "notion-nav-label" }
const _hoisted_12 = { class: "notion-nav-item notion-nav-item--toggle notion-nav-item--sub" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-nav-dot" }, null, -1))
const _hoisted_14 = { class: "notion-nav-label" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-nav-arrow" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-nav-dot" }, null, -1))
const _hoisted_17 = { class: "notion-nav-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMenuItems, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "notion-nav-section"
        }, [
          (item.heading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.translate(item.heading)), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
              (menuItem.heading)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    onClick: _ctx.toggleMenu,
                    class: "notion-nav-item",
                    "active-class": "notion-nav-item--active",
                    to: menuItem.route
                  }, {
                    default: _withCtx(() => [
                      (menuItem.fontIcon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _createElementVNode("i", {
                              class: _normalizeClass([menuItem.fontIcon, "bi"])
                            }, null, 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "to"]))
                : _createCommentVNode("", true),
              (menuItem.sectionTitle)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["notion-nav-accordion", { 'notion-nav-accordion--open': _ctx.hasActiveChildren(menuItem.route) }]),
                    "data-kt-menu-sub": "accordion",
                    "data-kt-menu-trigger": "click"
                  }, [
                    _createElementVNode("span", _hoisted_6, [
                      (menuItem.fontIcon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createElementVNode("i", {
                              class: _normalizeClass([menuItem.fontIcon, "bi"])
                            }, null, 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                      _hoisted_9
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["notion-nav-sub", { show: _ctx.hasActiveChildren(menuItem.route) }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                          (item2.heading)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "notion-nav-item notion-nav-item--sub",
                                "active-class": "notion-nav-item--active",
                                onClick: _ctx.toggleMenu,
                                to: item2.route
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10,
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "to"]))
                            : _createCommentVNode("", true),
                          (item2.sectionTitle)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["notion-nav-accordion", { 'notion-nav-accordion--open': _ctx.hasActiveChildren(item2.route) }]),
                                "data-kt-menu-sub": "accordion",
                                "data-kt-menu-trigger": "click"
                              }, [
                                _createElementVNode("span", _hoisted_12, [
                                  _hoisted_13,
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                  _hoisted_15
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["notion-nav-sub", { show: _ctx.hasActiveChildren(item2.route) }])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3, k2) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: k2 }, [
                                      (item3.heading)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            onClick: _ctx.toggleMenu,
                                            class: "notion-nav-item notion-nav-item--sub",
                                            "active-class": "notion-nav-item--active",
                                            to: item3.route
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_16,
                                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick", "to"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ], 2)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 2)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      }), 128))
    ])
  ], 512))
}